import React, { useEffect, useState, useCallback, useRef } from "react";
import { Link } from 'react-router-dom';
import axios from "axios";
import "../business&brands/BusinessBrands.css";
import { BACKEND_URL, fastApiCall, fastApiClient } from "../common/Common.js";


//Navbar and Left Section Images
import xmark from '../../assets/home-images/right-section-images/xmark.png';
import bluexmark from '../../assets/business and brands/bluexmark.png';

// import star from '../../assets/experience/star.png';

import popup_yatch from "../../assets/offers/popup_yatch.png";
import hayatlogo from '../../assets/home-images/right-section-images/hayatlogo.png';
import qr from '../../assets/home-images/right-section-images/qr.png';
import app_store from '../../assets/home-images/right-section-images/app_store.png';
import play_store from '../../assets/home-images/right-section-images/play_store.png';
import Navbar from "../common-component/navbar/Navbar.js";
import LeftSection from "../common-component/left-menu-section/LeftSection.js";
import search from '../../assets/home-images/search.png';
import nodata from '../../assets/experience/nodata.png';



const BusinessBrands = () => {
    const [states, setStates] = useState([]); // countrylist get api state
    const [getbrandlist, setGetbrandlist] = useState([]);
    const [downloadPopupOpen, setDownloadPopupOpen] = useState(false);
    const [latitude, setLatitude] = useState(null);
    const [longitude, setLongitude] = useState(null);
    const [selectedState, setSelectedState] = useState(null);
    const [loading, setLoading] = useState(true);
    const [loadingBrands, setLoadingBrands] = useState(true); // Start as true to show loading on initial load
    const [currentPage, setCurrentPage] = useState(1);
    const [hasMore, setHasMore] = useState(true);
    const perPage = 20; // Reduced from 1000 to 20 for better performance
    const observerRef = useRef(null);
    const [countrypopup, setCountrypopup] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [searchResults, setSearchResults] = useState([]);
    const [isSearching, setIsSearching] = useState(false);
    const [isSearchLoading, setIsSearchLoading] = useState(false);
    const searchDebounceTimerRef = useRef(null);
    const [isNearMeActive, setIsNearMeActive] = useState(false);
    const [categoryModalOpen, setCategoryModalOpen] = useState(false);
    const [categories, setCategories] = useState([]);
    const [selectedCategoryIds, setSelectedCategoryIds] = useState([]);
    const [isCategoriesLoading, setIsCategoriesLoading] = useState(false);

    // const [followingStates, setFollowingStates] = useState(
    //     new Array(data.length).fill(false)
    // );

    // const handleToggle = (index) => {
    //     const updated = [...followingStates];
    //     updated[index] = !updated[index];
    //     setFollowingStates(updated);
    // };


    useEffect(() => {
        // Set default location immediately to avoid waiting for geolocation
        setLatitude(24.4539);
        setLongitude(54.3773);

        // Try to get user's actual location (non-blocking)
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (position) => {
                    setLatitude(position.coords.latitude);
                    setLongitude(position.coords.longitude);
                },
                (error) => {
                    console.error("Error getting location:", error);
                    // Keep default values already set above
                },
                {
                    timeout: 5000, // 5 second timeout
                    enableHighAccuracy: false // Faster response
                }
            );
        }
    }, []);


    // const emirate = useEmirateFromCoordinates(latitude, longitude);

    const fetchMasterData = async () => {
        try {
            await fastApiCall(
                () => fastApiClient.get(`${BACKEND_URL}website/get-master-data`),
                setLoading, // Use main loading state
                (data) => {
                    const stateData = data?.stateData || [];
                    setStates(stateData);
                }
            );
        } catch (error) {
            console.error("Error fetching master data:", error);
            setStates([]);
        }
    };

    // Fetch business categories
    const fetchBusinessCategories = async () => {
        try {
            await fastApiCall(
                () => fastApiClient.get(`${BACKEND_URL}website/get-business-category`),
                setIsCategoriesLoading,
                (data) => {
                    // Handle different response structures
                    let categoriesData = [];
                    if (data) {
                        if (Array.isArray(data)) {
                            categoriesData = data;
                        } else if (data.data && Array.isArray(data.data)) {
                            categoriesData = data.data;
                        } else if (data.categories && Array.isArray(data.categories)) {
                            categoriesData = data.categories;
                        } else if (data.category_list && Array.isArray(data.category_list)) {
                            categoriesData = data.category_list;
                        }
                    }
                    setCategories(categoriesData);
                    console.log("Business Categories:", categoriesData);
                }
            );
        } catch (error) {
            console.error("Error fetching business categories:", error);
            setCategories([]);
        }
    };

    // const fetchGetbrandlist = async () => {
    //     try {
    //         const response = await axios.post(`${BACKEND_URL}website/get-brand-list`, {
    //             latitude: 24.5,
    //             longitude: 54.4,
    //             page: 1,
    //             per_page: 1000,
    //         });

    //         const data = response.data.data;
    //         setGetbrandlist(data);
    //         // console.log("Brands=", data);


    //     } catch (error) {
    //         console.error("Error fetching Brand list:", error);
    //     }
    // }

    const fetchBrandlist = useCallback(async (state, page = 1, append = false, categoryIdsOverride = null) => {
        const lat = parseFloat(state.latitude || state.lat || 24.4539);
        const lng = parseFloat(state.longitude || state.lng || 54.3773);

        // Use override categoryIds if provided, otherwise use state
        const categoryIdsToUse = categoryIdsOverride !== null ? categoryIdsOverride : selectedCategoryIds;

        const payload = {
            latitude: lat,
            longitude: lng,
            state_id: state.id || "",
            page: page,
            per_page: perPage,
            near_me: isNearMeActive ? true : "",
        };

        // Only include category_id if there are selected categories
        // Backend expects category_id as a JSON string when it's an array, not an actual array
        if (categoryIdsToUse.length > 0) {
            payload.category_id = JSON.stringify(categoryIdsToUse);
        }

        console.log("Fetching brands for:", payload);

        try {
            await fastApiCall(
                () => fastApiClient.post(`${BACKEND_URL}website/get-brand-list`, payload),
                setLoadingBrands,
                (responseData) => {
                    // Handle different response structures
                    const data = responseData?.data || responseData || [];
                    const pagination = responseData?.pagination || responseData;

                    // Check for pagination metadata
                    const total = pagination?.total || pagination?.total_count || 0;
                    const lastPage = pagination?.last_page || pagination?.total_pages || 0;
                    const currentPageNum = pagination?.current_page || pagination?.page || page;

                    // Update brand list
                    if (append) {
                        setGetbrandlist(prev => {
                            const newList = [...prev, ...data];
                            return newList;
                        });
                    } else {
                        setGetbrandlist(data);
                    }

                    // Determine if there's more data
                    // Use pagination metadata if available, otherwise use data length
                    let hasMoreData = false;
                    if (lastPage > 0) {
                        hasMoreData = currentPageNum < lastPage;
                    } else if (total > 0) {
                        // We'll calculate this after state update in a useEffect
                        // For now, use a simple check
                        const estimatedCurrentTotal = append ? (getbrandlist.length + data.length) : data.length;
                        hasMoreData = estimatedCurrentTotal < total;
                    } else {
                        // Fallback: if we got a full page, assume there's more
                        hasMoreData = data.length >= perPage;
                    }

                    setHasMore(hasMoreData);
                    setCurrentPage(currentPageNum);
                }
            );
        } catch (error) {
            console.error("Error fetching Brand list:", error);
            console.error("Request payload:", payload);
            if (error.response) {
                console.error("Error response:", error.response.data);
                console.error("Error status:", error.response.status);
            }
            setHasMore(false);
        }
    }, [perPage, isNearMeActive, selectedCategoryIds]);

    // Fetch initial brands using GPS coordinates
    useEffect(() => {
        // Coordinates are set immediately with defaults, so this will always run
        if (!selectedState) {
            fetchBrandlist({ 
                latitude: latitude || 24.4539, 
                longitude: longitude || 54.3773, 
                id: "" 
            }, 1, false);
        }
    }, [latitude, longitude, selectedState, fetchBrandlist]);


    useEffect(() => {
        fetchMasterData();
        // fetchGetbrandlist();
    }, []);

    // Fetch categories when modal opens
    useEffect(() => {
        if (categoryModalOpen && categories.length === 0) {
            fetchBusinessCategories();
        }
    }, [categoryModalOpen]);

    const changeEmirate = useCallback((state) => {
        const lat = parseFloat(state.latitude || state.lat || 24.4539);
        const lng = parseFloat(state.longitude || state.lng || 54.3773);

        console.log("🟢 Emirates Selected:", state.name, "Lat:", lat, "Lng:", lng);

        setSelectedState(state);
        setLatitude(lat);
        setLongitude(lng);
        setCountrypopup(false);
        setCurrentPage(1);
        setHasMore(true);

        fetchBrandlist(state, 1, false);
    }, [fetchBrandlist]);

    useEffect(() => {
        // Function to scroll to top
        const scrollToTop = () => {
            const middleSection = document.querySelector('.business-brand-middle-section');
            if (middleSection) {
                middleSection.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }
        };

        // Add event listener to home icon
        const homeIcon = document.querySelector('.homepage-icons a[href="/business-and-brands"]');
        if (homeIcon) {
            homeIcon.addEventListener('click', scrollToTop);
        }

        // Cleanup
        return () => {
            if (homeIcon) {
                homeIcon.removeEventListener('click', scrollToTop);
            }
            // Cleanup search debounce timer
            if (searchDebounceTimerRef.current) {
                clearTimeout(searchDebounceTimerRef.current);
            }
        };
    }, [])


    const lastBrandElementRef = useCallback(node => {
        if (loadingBrands) return;
        if (observerRef.current) observerRef.current.disconnect();
        observerRef.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasMore && !loadingBrands && !isSearching) {
                const nextPage = currentPage + 1;
                const stateToUse = selectedState || {
                    latitude: latitude || 24.4539,
                    longitude: longitude || 54.3773,
                    id: ""
                };
                fetchBrandlist(stateToUse, nextPage, true);
            }
        });
        if (node) observerRef.current.observe(node);
    }, [loadingBrands, hasMore, currentPage, selectedState, latitude, longitude, fetchBrandlist, isSearching]);

    // Search function that fetches all results (not limited by per_page)
    const fetchSearchResults = useCallback(async (searchValue) => {
        if (!searchValue || searchValue.trim() === "") {
            setSearchResults([]);
            setIsSearching(false);
            return;
        }

        setIsSearchLoading(true);
        setIsSearching(true);

        const stateToUse = selectedState || {
            latitude: latitude || 24.4539,
            longitude: longitude || 54.3773,
            id: ""
        };

        const lat = parseFloat(stateToUse.latitude || stateToUse.lat || 24.4539);
        const lng = parseFloat(stateToUse.longitude || stateToUse.lng || 54.3773);

        try {
            // Fetch with a large per_page to get all results, or fetch multiple pages
            const payload = {
                latitude: lat,
                longitude: lng,
                state_id: stateToUse.id || "",
                page: 1,
                per_page: 1000, // Large number to get all results for search
                search: searchValue.trim(), // Add search parameter if API supports it
                near_me: isNearMeActive ? true : "",
            };

            // Only include category_id if there are selected categories
            // Backend expects category_id as a JSON string when it's an array, not an actual array
            if (selectedCategoryIds.length > 0) {
                payload.category_id = JSON.stringify(selectedCategoryIds);
            }
            console.log(payload);
            
            await fastApiCall(
                () => fastApiClient.post(`${BACKEND_URL}website/get-brand-list`, payload),
                setIsSearchLoading,
                (responseData) => {
                    const data = responseData?.data || responseData || [];

                    // If API doesn't support search parameter, filter client-side
                    const searchLower = searchValue.toLowerCase().trim();
                    const searchValueStr = searchValue.trim();
                    const filtered = data.filter((brand) => {
                        const name = (brand.name || "").toLowerCase();
                        const city = (brand.city || "").toLowerCase();
                        const brandId = String(brand.id || "");
                        // Search in name, city, and ID (for number searches)
                        return name.includes(searchLower) ||
                            city.includes(searchLower) ||
                            brandId.includes(searchValueStr);
                    });

                    setSearchResults(filtered);
                }
            );
        } catch (error) {
            console.error("Error fetching search results:", error);
            setSearchResults([]);
        }
    }, [selectedState, latitude, longitude, isNearMeActive, selectedCategoryIds]);

    // Handle search input change
    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearchText(value);

        // Clear debounce timer
        if (searchDebounceTimerRef.current) {
            clearTimeout(searchDebounceTimerRef.current);
        }

        if (value.trim() === "") {
            setSearchResults([]);
            setIsSearching(false);
            return;
        }

        // Debounce search API call
        searchDebounceTimerRef.current = setTimeout(() => {
            fetchSearchResults(value);
        }, 300);
    };

    // Clear search
    const handleClearSearch = () => {
        setSearchText("");
        setSearchResults([]);
        setIsSearching(false);
        if (searchDebounceTimerRef.current) {
            clearTimeout(searchDebounceTimerRef.current);
        }
    };

    // Handle Near Me toggle
    const handleNearMeToggle = () => {
        const newNearMeState = !isNearMeActive;
        setIsNearMeActive(newNearMeState);
        setCurrentPage(1);
        setHasMore(true);

        // If searching, refetch search results; otherwise refetch brand list
        if (isSearching && searchText.trim()) {
            fetchSearchResults(searchText);
        } else {
            const stateToUse = selectedState || {
                latitude: latitude || 24.4539,
                longitude: longitude || 54.3773,
                id: ""
            };
            fetchBrandlist(stateToUse, 1, false);
        }
    };

    // Handle Near Me remove (when X is clicked)
    const handleNearMeRemove = () => {
        setIsNearMeActive(false);
        setCurrentPage(1);
        setHasMore(true);

        // If searching, refetch search results; otherwise refetch brand list
        if (isSearching && searchText.trim()) {
            fetchSearchResults(searchText);
        } else {
            const stateToUse = selectedState || {
                latitude: latitude || 24.4539,
                longitude: longitude || 54.3773,
                id: ""
            };
            fetchBrandlist(stateToUse, 1, false);
        }
    };

    // Handle category checkbox toggle
    const handleCategoryToggle = (categoryId) => {
        setSelectedCategoryIds(prev => {
            if (prev.includes(categoryId)) {
                return prev.filter(id => id !== categoryId);
            } else {
                return [...prev, categoryId];
            }
        });
    };

    // Handle clear all categories
    const handleClearAllCategories = () => {
        setSelectedCategoryIds([]);
    };

    // Handle show results from category modal
    const handleShowCategoryResults = () => {
        setCategoryModalOpen(false);
        setCurrentPage(1);
        setHasMore(true);
        setIsSearching(false); // Exit search mode when showing category results
        setSearchText(""); // Clear search text
        setSearchResults([]); // Clear search results

        // Fetch brand list with selected categories
        const stateToUse = selectedState || {
            latitude: latitude || 24.4539,
            longitude: longitude || 54.3773,
            id: ""
        };
        fetchBrandlist(stateToUse, 1, false);
    };

    // Shimmer component for brand cards
    const ShimmerBrandCard = () => (
        <div className="shimmer-brand-card">
            <div className="shimmer-brand-image"></div>
            <div className="shimmer-brand-logo"></div>
            <div className="shimmer-brand-details">
                <div className="shimmer-brand-title"></div>
                <div className="shimmer-brand-location"></div>
                <div className="shimmer-brand-offers"></div>
                <div className="shimmer-brand-button"></div>
            </div>
        </div>
    );

    // Render shimmer skeleton
    const renderShimmerSkeleton = (count = 6) => (
        <div className="shimmer-brand-container">
            {Array.from({ length: count }).map((_, index) => (
                <ShimmerBrandCard key={`shimmer-${index}`} />
            ))}
        </div>
    );

    return (
        <div>
            {/* <nav className="navbar">
                <div className="navbar-brand">
                    <a href="/">

                        <img src={hayatin} alt="hayatin" />
                    </a>
                </div>

                <div className="homepage-icons">
                    <Link to="/">
                        <img src={homeicon} alt="homeicon" />
                    </Link>

                    <Link to="/experience">
                        <img src={experienceicon} alt="experienceicon" />
                    </Link>

                    <Link>
                        <img src={businessicon} alt="businessicon" />
                    </Link>

                </div>

                <div className="registerbtn-icons">
                    <div className="register-business">
                        <a href="https://www.hayatinapp.com/vendor/register" >
                            <button className="register-business-btn">
                                Register Your Business
                            </button>
                        </a>
                    </div>


                </div>

            </nav> */}
            <Navbar
                selectedState={selectedState}
                onStateChange={changeEmirate}
                states={states}
                showLocationSelector={true}
            />

            <div className="experience-main-layout">
                <LeftSection
                    selectedState={selectedState}
                    onStateChange={changeEmirate}
                    states={states}
                    showLocationSelector={true}
                />



                <main className="business-brand-middle-section">
                    <div className="business-brands-container">
                        <div className="bussiness-heading-div">
                            <h4>Businesses & Brands</h4>
                            {/* <div className="business-brands-menu-map-div">
                                <img src={menuicon} alt="menu icon" className="menu-icon" />
                                <img src={mapicon} alt="map icon" className="map-icon" />
                            </div> */}
                        </div>
                        <div className="business-brands-nearme-following-category-div">
                            {isNearMeActive ? (
                                <div className="near-me-filter-tag" onClick={handleNearMeRemove}>
                                    <span>Near me</span>
                                    <img
                                        src={bluexmark}
                                        alt="remove"
                                        className="near-me-remove-icon"
                                    />
                                </div>
                            ) : (
                                <p onClick={handleNearMeToggle}>Near me</p>
                            )}
                            <p onClick={() => setDownloadPopupOpen(true)}>Following</p>
                            {selectedCategoryIds.length > 0 ? (
                                <div className="category-filter-tag" onClick={() => setCategoryModalOpen(true)}>
                                    <span>Category</span>
                                    <img
                                        src={bluexmark}
                                        alt="remove"
                                        className="category-remove-icon"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleClearAllCategories();
                                        }}
                                    />
                                </div>
                            ) : (
                                <p onClick={() => setCategoryModalOpen(true)}>Category</p>
                            )}
                        </div>
                        <div className="mobile-search-container-business">
                            <div className="business-and-brands mobile-search-box">
                                <img src={search} alt="search" />
                                <input
                                    type="text"
                                    placeholder="Search Businesses & Brands..."
                                    value={searchText}
                                    onChange={handleSearchChange}
                                />
                                {searchText && (
                                    <img
                                        src={xmark}
                                        alt="clear"
                                        className="search-clear-icon"
                                        onClick={handleClearSearch}
                                    />
                                )}
                            </div>
                        </div>
                        <div className="business-brands-body">
                            {/* <div className="total-business-count">
                                    <p>{isSearching ? (searchResults?.length || 0) : (getbrandlist?.length || 0)} Businesses</p>
                                </div> */}
                            {isSearching ? (
                                // Show search results
                                isSearchLoading ? (
                                    renderShimmerSkeleton(6)
                                ) : searchResults.length === 0 ? (
                                    <div className="nodata-message-categorylist">
                                        <img src={nodata} alt="no data" className="no-data-img" />
                                        <p className="no-data-p1">No businesses found</p>
                                        <p className="no-data-p2">Come back later to explore</p>
                                    </div>
                                ) : (
                                    <div className="business-brands-grid-container">
                                        {searchResults.map((item, index) => (
                                            <div
                                                className="group-brandimg-brandlogo-branddetails"
                                                key={`search-${item.id}-${index}`}
                                            >
                                                <Link
                                                    to={`/vendordetails/${item.id}`}
                                                    className="remove-underline"
                                                >
                                                    <img
                                                        src={item.cover_image}
                                                        className="brand-images"
                                                        alt="brand images"
                                                        loading="lazy"
                                                        decoding="async"
                                                    />
                                                    <img
                                                        src={item.profile_image}
                                                        className="brand-logo"
                                                        alt="brand logo"
                                                        loading="lazy"
                                                        decoding="async"
                                                    />
                                                </Link>

                                                <div className="brand-details">
                                                    <div className="brand-title-row">
                                                        <Link
                                                            to={`/vendordetails/${item.id}`}
                                                            className="remove-underline brand-title-link"
                                                        >
                                                            <h5>{item.name}</h5>
                                                        </Link>
                                                        <div className="follow-button-div">
                                                            <button className="follow-button" onClick={() => setDownloadPopupOpen(true)}>
                                                                {item.is_following ? "Following" : "Follow"}
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <Link
                                                        to={`/vendordetails/${item.id}`}
                                                        className="remove-underline"
                                                    >
                                                        <p>{item.distance ? item.distance.toFixed(1) : '0.0'} km | {item.city}</p>
                                                        {item.coupon_count > 0 && (
                                                            <p className="offer-events">{item.coupon_count} Offers</p>
                                                        )}
                                                    </Link>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )
                            ) : loadingBrands && getbrandlist.length === 0 ? (
                                renderShimmerSkeleton(6)
                            ) : getbrandlist.length === 0 && !loadingBrands ? (
                                <div className="nodata-message-categorylist">
                                    <img src={nodata} alt="no data" className="no-data-img" />
                                    <p className="no-data-p1">No businesses found</p>
                                    <p className="no-data-p2">Come back later to explore</p>
                                </div>
                            ) : (
                                <>
                                    <div className="business-brands-grid-container">
                                        {getbrandlist?.map((item, index) => {
                                            const isLastElement = index === getbrandlist.length - 1;
                                            return (
                                                <div
                                                    className="group-brandimg-brandlogo-branddetails"
                                                    key={`${item.id}-${index}`}
                                                    ref={isLastElement ? lastBrandElementRef : null}
                                                >
                                                    <Link
                                                        to={`/vendordetails/${item.id}`}
                                                        className="remove-underline"
                                                    >
                                                        <img
                                                            src={item.cover_image}
                                                            className="brand-images"
                                                            alt="brand images"
                                                            loading={index < 12 ? "eager" : "lazy"}
                                                            decoding="async"
                                                        />
                                                        <img
                                                            src={item.profile_image}
                                                            className="brand-logo"
                                                            alt="brand logo"
                                                            loading={index < 12 ? "eager" : "lazy"}
                                                            decoding="async"
                                                        />
                                                    </Link>

                                                    <div className="brand-details">
                                                        <div className="brand-title-row">
                                                            <Link
                                                                to={`/vendordetails/${item.id}`}
                                                                className="remove-underline brand-title-link"
                                                            >
                                                                <h5>{item.name}</h5>
                                                            </Link>
                                                            <div className="follow-button-div">
                                                                <button className="follow-button" onClick={() => setDownloadPopupOpen(true)}>
                                                                    {item.is_following ? "Following" : "Follow"}
                                                                </button>
                                                                {/* <p className="star-tag">5.0 <span> <img src={star} alt="star" className="star" /></span></p> */}
                                                            </div>
                                                        </div>
                                                        <Link
                                                            to={`/vendordetails/${item.id}`}
                                                            className="remove-underline"
                                                        >
                                                            <p>{item.distance ? item.distance.toFixed(1) : '0.0'} km <span className="dividerforkm-city-businesspage">|</span> {item.city}</p>
                                                            {item.coupon_count > 0 && item.event_count > 0 && (
                                                                <p className="offer-events">
                                                                    {item.coupon_count} Offers | {item.event_count} Event
                                                                </p>
                                                            )}

                                                        </Link>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                    {loadingBrands && getbrandlist.length > 0 && (
                                        <div style={{ textAlign: 'center', padding: '20px' }}>
                                            <div style={{
                                                display: 'inline-block',
                                                width: '40px',
                                                height: '40px',
                                                border: '4px solid #f3f3f3',
                                                borderTop: '4px solid #d9d9d9',
                                                borderRadius: '50%',
                                                animation: 'spin 1s linear infinite',
                                                marginBottom: '10px'
                                            }}></div>
                                            <p style={{ marginTop: '10px', color: '#666' }}>Loading more businesses...</p>
                                            <style>{`
                                                @keyframes spin {
                                                    0% { transform: rotate(0deg); }
                                                    100% { transform: rotate(360deg); }
                                                }
                                            `}</style>
                                        </div>
                                    )}
                                </>
                            )}
                        </div>

                    </div>


                </main>

                {downloadPopupOpen && (
                    <>
                        <div className="overlay" onClick={() => setDownloadPopupOpen(false)}></div>
                        <div className="download-popup-drawer">
                            <div className="pop-up-img">
                                <img src={popup_yatch} alt="pop up yatch" className="pop-up-yatch" />
                            </div>
                            <div className="popup-header">
                                <div className="pop-up-download">
                                    <div className="hayaticon">
                                        <img src={hayatlogo} alt="Hayat In Logo" />
                                        <div className="close-btn">
                                            <img src={xmark} alt="xmark" className="close-popup" onClick={() => setDownloadPopupOpen(false)} />
                                        </div>
                                    </div>
                                    <h4 className="download-hayat">Download Our App </h4>
                                    <p id="App-description">
                                        Scan the QR code with your phone and open Hayat In instantly
                                        Your gateway to discovering the city in one tap.                                    </p>

                                    <div className="store-buttons">
                                        <div className="app_qr">
                                            <a
                                                href="https://apps.apple.com/ae/app/hayat-in/id6738689937"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <img src={app_store} alt="App Store" />
                                            </a>

                                            <a
                                                href="https://play.google.com/store/apps/details?id=com.hayatinapp.hayatin"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <img src={play_store} alt="Google Play" />
                                            </a>
                                        </div>


                                        <div className="app_qr">
                                            <img className="qr" src={qr} alt="QR code" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </>
                )}

                {/* Category Filter Modal */}
                {categoryModalOpen && (
                    <>
                        <div className="overlay" onClick={() => setCategoryModalOpen(false)}></div>
                        <div className="category-filter-modal">
                            <div className="category-modal-header">
                                <h3>Find Businesses & Brands by Categories</h3>
                                <img
                                    src={xmark}
                                    alt="close"
                                    className="category-modal-close"
                                    onClick={() => setCategoryModalOpen(false)}
                                />
                            </div>
                            <div className="category-modal-content">
                                {isCategoriesLoading ? (
                                    <div className="category-loading">Loading categories...</div>
                                ) : (
                                    <div className="category-grid">
                                        {categories.map((category) => (
                                            <div
                                                key={category.id || category.category_id}
                                                className="category-checkbox-item"
                                            >
                                                <label className="category-checkbox-label">
                                                    <input
                                                        type="checkbox"
                                                        checked={selectedCategoryIds.includes(category.id || category.category_id)}
                                                        onChange={() => handleCategoryToggle(category.id || category.category_id)}
                                                        className="category-checkbox-input"
                                                    />
                                                    <span className="category-checkbox-text">
                                                        {category.category_name || category.name || category.title}
                                                    </span>
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                            <div className="category-modal-footer">
                                <button
                                    className="category-clear-btn"
                                    onClick={handleClearAllCategories}
                                >
                                    Clear All
                                </button>
                                <button
                                    className="category-show-results-btn"
                                    onClick={handleShowCategoryResults}
                                >
                                    Show Results
                                </button>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    )
}

export default BusinessBrands